<template>
	<a
		:href="href"
		:target="openNewTab ? '_blank' : '_self'"
		tabindex="0"
		class="bbox-link"
		:class="[colors, { disabled, block }]"
	>
		<slot></slot>
	</a>
</template>

<script>
export default {
	name: 'b-link',
	components: {},
	props: {
		/**
		 * Se o link irá abrir em uma nova aba ou não.
		 */
		openNewTab: Boolean,
		/**
		 * O endereço do link desejado
		 */
		href: String,
		/**
		 * Se true botão fica desabilitado
		 */
		disabled: Boolean,
		/**
		 * Se true botão tem `display: block`
		 */
		block: Boolean,
		/**
		 * Seta a cor do link, pode ser qualquer cor base disponível no DLS
		 */
		color: {
			type: String,
			default: 'blue',
		},
	},
	computed: {
		colors() {
			var classNames = '';
			var color = this.color;
			if (this.disabled) {
				classNames = 'ink-lighter-3 active-ink-lighter-2';
			} else {
				if (this.color === 'gray' || this.color === 'grey') {
					classNames = `ink-lighter-1
                        active-ink-base
                        focus-ink-base
                        hover-ink-base
                        border-none`;
				} else if (this.color === 'white') {
					classNames = `white-base
                        active-white-darker-1
                        focus-white-darker-1
                        hover-white-darker-1
                        border-none`;
				} else {
					classNames = `${color}-base
                        active-${color}-darker-2
                        focus-${color}-darker-1
                        hover-${color}-darker-1
                        border-none`;
				}
			}
			return classNames;
		},
	},
};
</script>

<style scoped lang="scss">
.bbox-link {
	background: transparent;
	box-shadow: none;
	&.disabled {
		background: transparent !important;
		border: none !important;
	}
	&.block {
		display: block;
	}
}
</style>

<docs>
    Link padrão do DLS

    As importações dos arquivos abaixo são necessárias para o funcionamento do componente:
    - styling.scss
    - spacing.scss

    ```js
    <b-link>Default</b-link>
    <b-link disabled>Disabled</b-link>
    <b-link block>Block</b-link>
    <b-link block disabled>Block + Disabled</b-link>
    <b-link color="yellow">Yellow</b-link>
    <b-link block color="yellow">Yellow + Block</b-link>

    ```
</docs>
